import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import classNames from 'classnames';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled';
import PropTypes from 'prop-types';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import TvIcon from '@material-ui/icons/Tv';
import { withStyles } from '@material-ui/core/styles';
import { FOOTER_HEIGHT_MOBILE } from '../../base/constants';

const itemStyles = {
  root: {
    '&$selected': {
      paddingTop: 8, // overwrite selected's behaviour
    },
  },
};
const ItemComponent = (props) => <BottomNavigationAction {...props} />;
const Item = withStyles(itemStyles)(ItemComponent);

const containerStyles = (props) => ({
  root: {
    backgroundColor: '#000000',
    bottom: 0,
    height: FOOTER_HEIGHT_MOBILE,
    left: 0,
    position: 'fixed',
    width: '100%',
    zIndex: 20,
    '@media (max-width: 960px) and (orientation: landscape)': {
      '&.isMobile': {
        display: 'none',
      },
    },
  },
});

class FooterMenu extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    redirectToTrending: PropTypes.func.isRequired,
    redirectToVod: PropTypes.func.isRequired,
    redirectToWatch: PropTypes.func.isRequired,
    isChatBarShown: PropTypes.bool.isRequired,
    trendingVisible: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool.isRequired,
    page: PropTypes.string.isRequired,
  };

  render() {
    const {
      classes,
      redirectToTrending,
      redirectToVod,
      redirectToWatch,
      isChatBarShown,
      trendingVisible,
      t,
      page,
      isMobile,
    } = this.props;

    return (
      <div>
        {!isChatBarShown
          ? [
              <BottomNavigation
                className={classNames(classes.root, { isMobile: isMobile })}
                showLabels
                value={page}
                key="Footer Tabs"
              >
                <Item
                  icon={<TvIcon />}
                  value="Watch"
                  label={t('live_tv')}
                  onClick={redirectToWatch}
                />
                <Item
                  icon={<PlayCircleFilled />}
                  value="Vod"
                  label={t('on_demand')}
                  onClick={redirectToVod}
                />
                {trendingVisible && (
                  <Item
                    icon={<TrendingUpIcon />}
                    value="Trending"
                    label={t('trending')}
                    onClick={redirectToTrending}
                  />
                )}
              </BottomNavigation>,
            ]
          : null}
      </div>
    );
  }
}

export const FooterMenuComponent = withStyles(containerStyles)(withNamespaces()(FooterMenu));
